import type { RouteLocationRaw } from 'vue-router'

const PROXY_FUNCTIONS = ['push', 'replace']

export function useLocaleRouter() {
  const { locale } = useI18n()
  const router = useRouter()
  const localePath = useLocalePath()

  return new Proxy(router, {
    get(target, prop) {
      if (typeof prop === 'string' && PROXY_FUNCTIONS.includes(prop)) {
        return (route: RouteLocationRaw) => Reflect.get(target, prop)(localePath(route, locale.value))
      }
      return Reflect.get(target, prop)
    },
  })
}

export function useRouterState() {
  const router = useLocaleRouter()

  const backPath = computed(() => router.options.history.state?.back as Nullable<string>)
  const isNavigatedByRouter = computed(() => !router.options.history.state?.replaced)

  return { backPath, isNavigatedByRouter }
}
